import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';

import { fetchActiveProperty } from '../../store/core/companySlice';


export default function PlatformPropertySelector() {
  const dispatch = useDispatch();
  const activePropertyCode = useSelector((state) => state.user.activeProperty);
  const availableProperties = useSelector((state) => state.company.properties);
  const activePropertyDetails = useSelector((state) => state.company.activeProperty);

  const activeProperty = activePropertyDetails?.code === activePropertyCode
    ? activePropertyDetails
    : availableProperties.find((property) => property.code === activePropertyCode);

  if (availableProperties.length <= 1) {
    return null;
  }

  return (
    <Stack
      spacing={0.5}
      sx={{
        minWidth: { xs: '100%', md: 260 },
        width: { xs: '100%', md: 'auto' },
        justifySelf: 'end',
      }}
    >
      <Box>
        <FormControl size="small" fullWidth>
          <InputLabel id="platform-property-select-label">Property</InputLabel>
          <Select
            labelId="platform-property-select-label"
            value={activePropertyCode || ''}
            label="Property"
            onChange={(event) => dispatch(fetchActiveProperty(event.target.value))}
          >
            {availableProperties.map((property) => (
              <MenuItem key={property.code} value={property.code}>
                {property.code} {property.name ? `· ${property.name}` : ''}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Stack>
  );
}